// extracted by mini-css-extract-plugin
module.exports = {"grid":"style_grid__3l4VJ","column":"style_column__1NRzq","row":"style_row__1b_FF"};